import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary text-left" }, "Enviar nova folha", -1)
const _hoisted_2 = { class: "flex flex-col gap-4 text-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-neutral50" }, [
  /*#__PURE__*/_createTextVNode(" A folha atual foi recusada e continuará disponível em “Folhas anteriores”. Ao enviar, o registro volta para "),
  /*#__PURE__*/_createElementVNode("b", null, "Aguardando Auditoria"),
  /*#__PURE__*/_createTextVNode(" com um novo prazo, e as linhas já transcritas voltam a ficar pendentes de conciliação. ")
], -1)
const _hoisted_4 = { class: "flex flex-col sm:flex-row sm:justify-end gap-3" }

import { computed, ref, watch } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import StepFile from '@/components/designSystem/modals/AttendanceUploadModal/StepFile.vue'

/**
 * rejected-sheet-resubmission (G1, CA4): a Auditoria anexa a folha corrigida ao
 * registro reprovado. O mínimo da justificativa espelha o DTO do backend (BE-3).
 */
const MIN_JUSTIFICATION = 10


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceNewSheetModal',
  props: {
    modelValue: { type: Boolean },
    saving: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit }) {

const props = __props;




const file = ref<File | null>(null)
const justification = ref('')

watch(
  () => props.modelValue,
  (open) => {
    if (open) {
      file.value = null
      justification.value = ''
    }
  }
)

const trimmed = computed(() => justification.value.trim())
const canSend = computed(() => !!file.value && trimmed.value.length >= MIN_JUSTIFICATION)
const justificationHint = computed(() =>
  trimmed.value.length < MIN_JUSTIFICATION
    ? `Obrigatória — mínimo de ${MIN_JUSTIFICATION} caracteres`
    : ''
)

function close() {
  emit('update:modelValue', false)
}

function confirm() {
  if (!canSend.value || props.saving || !file.value) return
  emit('confirm', { file: file.value, justification: trimmed.value })
}

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[560px]",
    onClose: close
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "96px",
          height: "40px",
          "data-testid": "new-sheet-cancel-button",
          onClick: close
        }),
        _createVNode(FilledButton, {
          text: "Enviar nova folha",
          width: "180px",
          height: "40px",
          disabled: !canSend.value || _ctx.saving,
          "data-testid": "new-sheet-confirm-button",
          onClick: confirm
        }, null, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(StepFile, {
          modelValue: file.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((file).value = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_textarea, {
          modelValue: justification.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((justification).value = $event)),
          label: "Justificativa",
          placeholder: "Ex.: folha corrigida enviada pelo profissional via Suporte",
          variant: "outlined",
          density: "compact",
          rows: "3",
          counter: "1000",
          maxlength: "1000",
          hint: justificationHint.value,
          "persistent-hint": "",
          "data-testid": "new-sheet-justification"
        }, null, 8, ["modelValue", "hint"])
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})